import axios, { type AxiosResponse } from 'axios';
import { getConfig } from './config';
import { HttpError } from './error';

const DEFAULT_NETWORK_ERROR = {
  name: 'Network Error',
  message: 'A network error occurred. Please try again.',
};

function rejectWith(error: HttpError, request: { url?: string; method?: string }): never {
  getConfig().onResponseError?.(error, request);
  throw error;
}

async function httpErrorHandler(error: unknown) {
  if (!axios.isAxiosError(error) || error === null) {
    throw new Error(`Unknown error: ${JSON.stringify(error)}`);
  }

  const response = error.response;
  const request = { url: error.config?.url, method: error.config?.method };

  if (!response) {
    return rejectWith(new HttpError(getConfig().networkError ?? DEFAULT_NETWORK_ERROR), request);
  }

  const data = response.data as Record<string, unknown>;
  const { name, message, code } = {
    name: (data?.title as string) ?? 'Error',
    message: (data?.message as string) ?? 'An error occurred.',
    code: data?.code as string | undefined,
  };

  const formContexts = Array.isArray(data?.formContexts) ? (data.formContexts as Record<string, unknown>[]) : undefined;

  return rejectWith(new HttpError({ name, message, status: response.status, code, formContexts }), request);
}

export function responseHandler(response: AxiosResponse) {
  return response;
}

export function responseErrorHandler(error: unknown) {
  return httpErrorHandler(error);
}
